// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.cardRiepilogo{
    display: flex;
    text-align: left;
}

.titlePage{
    display: flex;
    text-align: text;
    font-size: 20px;
    font-weight:bold;
    gap: 10px;
    padding-left: 10%;
}
#dropdown-menu-align-end{
    background-color: transparent;
    border-color: #F4BC16;
    color: #F4BC16;
}
.riepilogoDIV{
    width: 90%;
    padding-right: 20%;
}
.spese{
    display: flex;
    flex-direction: row;
    align-content: space-around;
    justify-content: space-between;
    align-items: center;
    color: A0CED9;
    border-bottom: solid A0CED9 1px;
    width: 100%;
}

.Value{
    color: black;
    margin-left: 10px;
    
}

.bodyspese{
    font-weight: bold;
    border:none;
    width: 95%;

}
.infospese{
    color: black;
    font-size: 12px;
}

.tot{
    /* padding: 0px 10px 0px 10px; */
    font-size: 20px;
    border: none;
}


@media only screen and (max-width: 767px) {
    .CardDiv{
      width: 100%;
      padding-left: 0%;
      padding-right: 0%;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1050px){
    .CardDiv{
      width: 100%;
      padding-left: 0%;
      padding-right: 0%;
    }
  }
  @media only screen and (min-width: 1050px) {
    .CardDiv{
      width: 80%;
      padding-left: 15%;
      padding-right: 15%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/Riepilogo/Riepilogo.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;;AAErB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,UAAU;;AAEd;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,YAAY;AAChB;;;AAGA;IACI;MACE,WAAW;MACX,gBAAgB;MAChB,iBAAiB;IACnB;EACF;EACA;IACE;MACE,WAAW;MACX,gBAAgB;MAChB,iBAAiB;IACnB;EACF;EACA;IACE;MACE,UAAU;MACV,iBAAiB;MACjB,kBAAkB;IACpB;EACF","sourcesContent":["\n\n.cardRiepilogo{\n    display: flex;\n    text-align: left;\n}\n\n.titlePage{\n    display: flex;\n    text-align: text;\n    font-size: 20px;\n    font-weight:bold;\n    gap: 10px;\n    padding-left: 10%;\n}\n#dropdown-menu-align-end{\n    background-color: transparent;\n    border-color: #F4BC16;\n    color: #F4BC16;\n}\n.riepilogoDIV{\n    width: 90%;\n    padding-right: 20%;\n}\n.spese{\n    display: flex;\n    flex-direction: row;\n    align-content: space-around;\n    justify-content: space-between;\n    align-items: center;\n    color: A0CED9;\n    border-bottom: solid A0CED9 1px;\n    width: 100%;\n}\n\n.Value{\n    color: black;\n    margin-left: 10px;\n    \n}\n\n.bodyspese{\n    font-weight: bold;\n    border:none;\n    width: 95%;\n\n}\n.infospese{\n    color: black;\n    font-size: 12px;\n}\n\n.tot{\n    /* padding: 0px 10px 0px 10px; */\n    font-size: 20px;\n    border: none;\n}\n\n\n@media only screen and (max-width: 767px) {\n    .CardDiv{\n      width: 100%;\n      padding-left: 0%;\n      padding-right: 0%;\n    }\n  }\n  @media only screen and (min-width: 768px) and (max-width: 1050px){\n    .CardDiv{\n      width: 100%;\n      padding-left: 0%;\n      padding-right: 0%;\n    }\n  }\n  @media only screen and (min-width: 1050px) {\n    .CardDiv{\n      width: 80%;\n      padding-left: 15%;\n      padding-right: 15%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
